<template>
    <div class="px-1 mt-2">
        <svg width="7" height="30" viewBox="0 0 7 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="1.00117" height="30.3846" transform="matrix(0.975942 0.21803 -0.198222 0.980157 6.02246 0)" fill="#D7DAE0" />
        </svg>
    </div>
</template>
